import { render } from "./TimestampFormatter.vue?vue&type=template&id=64ee4395&scoped=true"
import script from "./TimestampFormatter.vue?vue&type=script&lang=js"
export * from "./TimestampFormatter.vue?vue&type=script&lang=js"

import "./TimestampFormatter.vue?vue&type=style&index=0&id=64ee4395&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ee4395"]])

export default __exports__